import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";

import { environments } from '../../../../environments/environment';
import { ArchivoAdjuntoResponseModel } from "src/app/domain/models/archivo-adjunto/archivo-adjunto-response.model";
import { ArchivoAdjuntoGateway } from "src/app/domain/models/archivo-adjunto/gateways/archivo-adjunto.gateway";
import { ArchivoAdjuntoUpload, ArchivoAdjuntoUploadResponseModel } from "src/app/domain/models/archivo-adjunto/archivo-adjunto-upload.model";


@Injectable({
    providedIn: 'root'
})
export class ArchivoAdjuntoAdapter extends ArchivoAdjuntoGateway {
    _back_url_base: string;

    constructor(private http: HttpClient) {
        super();
        this._back_url_base = environments.BACK_URL_BASE;
    }

    ObtenerUrl(data: string): Observable<ArchivoAdjuntoResponseModel> {
        const url = `${this._back_url_base}api/factura-adjuntos/get-url/${data}`;
        return this.http.get<ArchivoAdjuntoResponseModel>(
            url
        );
    }

    override upload(data: ArchivoAdjuntoUpload): Observable<ArchivoAdjuntoUploadResponseModel> {
        const url = `${this._back_url_base}api/factura-adjuntos/upload`;
        return this.http.post<ArchivoAdjuntoUploadResponseModel>(
            url,
            data
        );
    }
}